import { ReturnIcon } from "../../assets/icons/ReturnIcon";
import { useTranslate } from "@made-people/grease-translations";
import { useMaybeProductBase, ProductBase } from "@made-people/grease-product";

const isGiftcard = (productBase: ProductBase | undefined): boolean => {
  if (!productBase) return false;

  const productTypeAttr = productBase.attributes.find(
    (attr) => attr.attributeKey === "product_type",
  );
  if (productTypeAttr?.value && typeof productTypeAttr.value === "string") {
    return productTypeAttr.value.toLowerCase() === "giftcard";
  }

  const categoryName = productBase.categories[0]?.name;
  if (categoryName?.toLowerCase().includes("giftcard")) {
    return true;
  }

  return productBase.slug.toLowerCase().includes("giftcard");
};

export const ReturnPolicyBlock = () => {
  const translate = useTranslate();
  const productBase = useMaybeProductBase();

  if (isGiftcard(productBase)) return null;

  return (
    <div className="flex items-center gap-2">
      <ReturnIcon className="w-5 h-5 shrink-0" />
      <span className="text-body-sm uppercase font-medium leading-tight">
        {translate("100_Washes_Guarantee_Return")}
      </span>
    </div>
  );
};
